import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'

export interface ErrorWithCode {
  code: string
  field: Nullable<string>
  message: string
}

interface ErrorsWithCodesResponse {
  errors_with_codes?: ErrorWithCode[]
}

export const getErrorsWithCodes = (err: unknown): ErrorWithCode[] => {
  if (!(err instanceof RepoError)) return []

  return (
    (err.response as ErrorsWithCodesResponse | undefined)?.errors_with_codes ??
    []
  )
}
